export var PixElementType;
(function (PixElementType) {
    PixElementType["DYNAMIC"] = "DYNAMIC";
    PixElementType["STATIC"] = "STATIC";
    PixElementType["INVALID"] = "INVALID";
})(PixElementType || (PixElementType = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGl4RWxlbWVudHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvdHlwZXMvcGl4RWxlbWVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBY0EsTUFBTSxDQUFOLElBQVksY0FJWDtBQUpELFdBQVksY0FBYztJQUN4QixxQ0FBbUIsQ0FBQTtJQUNuQixtQ0FBaUIsQ0FBQTtJQUNqQixxQ0FBbUIsQ0FBQTtBQUNyQixDQUFDLEVBSlcsY0FBYyxLQUFkLGNBQWMsUUFJekIifQ==